import Component, { getServerSideProps as getServerSidePropsAlia } from "..";

export default Component;
export const getServerSideProps = getServerSidePropsAlia;
